import { FormattedMessage } from "react-intl";

import { FileModalMode } from "../utils/file-modal-mode";

interface ProcessRunFormFileActionLabelProps {
  mode: FileModalMode;
  hasValue: boolean;
}

export function ProcessRunFormFileActionLabel({
  mode,
  hasValue,
}: ProcessRunFormFileActionLabelProps) {
  if (mode === "input-directory") {
    return <FormattedMessage id="process.select_folder" defaultMessage="Select folder" />;
  }

  if (mode === "output-file" || mode === "output-directory") {
    return hasValue ? (
      <FormattedMessage id="process.change" defaultMessage="Change" />
    ) : (
      <FormattedMessage id="process.save_as" defaultMessage="Save as" />
    );
  }

  return hasValue ? (
    <FormattedMessage id="process.change_file" defaultMessage="Change file" />
  ) : (
    <FormattedMessage id="process.select_file" defaultMessage="Select file" />
  );
}
